<template>
    <el-dialog class="dialog-order-info" title="修改日期设置" :visible.sync="dialogVisible" width="35%">
        <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">

            <el-form-item label="日期 :" prop="beginTime">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.beginTime"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>

            <el-form-item label="开馆状态:" prop="twoLevelType">
                <el-select v-model="form.isopen" placeholder="请选择开馆状态">
                    <el-option v-for="item in openList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="启用状态 :" prop="twoLevelType">
                <el-select v-model="form.isused" placeholder="请选择启用状态">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="开始时间 :" prop="beginTime">
                <el-date-picker type="datetime" placeholder="选择日期" v-model="form.beginTime"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间 :" prop="endTime">
                <el-date-picker type="datetime" placeholder="选择日期" v-model="form.endTime"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>
        </el-form>

        <div slot="footer" class="footer mt-30">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submit" type="primary" :loading="loadingSave">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                day: '',
                isopen: '',
                isused: '',
                beginTime: '',
                endTime: ''
            },
            openList: [{ label: '开馆', value: '1' }, { label: '闭馆', value: '2' }, { label: '临时开馆', value: '3' }, { label: '临时闭馆', value: '4' }],
            statusList: [{ label: '未启用', value: '1' }, { label: '已启用', value: '2' }],
            pageType: '',
            rules: {
                day: [
                    { required: true, message: '日期不能为空', trigger: 'blur' }
                ],
                isopen: [
                    { required: true, message: '开馆状态不能为空', trigger: 'blur' }
                ],
                isused: [
                    { required: true, message: '启用状态不能为空', trigger: 'blur' }
                ],
                beginTime: [
                    { required: true, message: '开始预约时间不能为空', trigger: 'blur' }
                ],
                endTime: [
                    { required: true, message: '停止预约时间不能为空', trigger: 'blur' }
                ]
            },
            listQuery: {
                currentPage: 1,
                size: 10
            },
            loadingSave: false,
            chooseRowIds: '' // 当前导出选中藏品id
        }
    },
    methods: {
        init() {
            this.dialogVisible = true
            this.getData()
        },

        getData() {
            this.listLoading = true
            this.tableData = []
            this.$api.applet.getDigitalExhibitionList({
                ...this.listQuery
            }).then(res => {
                this.listLoading = false
                if (res.success) {
                    if (res.result && res.result.records) {
                        this.tableData = res.result.records
                        this.total = res.result.total
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        cancel() {
            this.$refs['form'].resetFields()
            this.dialogVisible = false
        },

        submit() { }
    }
}
</script>

<style lang="scss" scoped></style>